var MessageCh = {

  NavabarText: {
    navbar_home: "主页",
    navbar_about: "关于我们",
    navbar_search: "查询报告",
    navbar_contact: "联络我们",
    navbar_item: "服务项目",
    navbr_new: '最新消息'
  },
  About_Navbar: {
    Company: '公司简介',
    Horor: '荣誉与资质',
    Technology: '科研技术',
    Team: '我们的团队',
  },
  Item_NavBar: {
    YC_DNA_Test: '母血Y染色体检测',
    Non_Prenatal_Test: '无创产前基因检测',
    Non_Paternity_Test: '亲子鉴定（产前或产后）',
    Prenatal_And_Postpartum: '(产前和产后)',
  },
  New_NavBar: {
    Notice: '公司通告',
    MediaCentre: '媒体中心',
  },
  indexText: {

    more: "了解更多",

  },
  footText: {
    address: "香港新界火炭坳背湾街2-12号，威力工业中心，9楼N室",
    address_prefix: "香港新界火炭坳背湾街2-12号，",
    address_suffix: "威力工业中心，9楼N室",
    address_prefix1: "香港新界火炭坳背湾街2-12号，威力工业中心，9楼N室",
    phone: "(+852) 3100 0477",
    email: "info@hkmedilab.com",
    weixin: "扫码关注公众号",
    aboutUs: '关于我们',
    company: '公司简介',
    honor: '荣誉与资质',
    technology: '科研技术',
    team: '我们的团队',
    services: '服务项目',
    chromosomeText: '母血Y染色体检测',
    invasivePrenatalTest: '无创产前基因检测',
    invasivePaterNityTest: '亲子鉴定(产前或产后)',
    special: '(产前和产后)',
    news: '最新消息',
    notice: '公司通告',
    mediaCentre: '媒体中心',
    report: '查询报告',
    contact: '联络我们',
    talentRecruitment: '人才招聘',
    OfficeHours: '营业时间',
    day1: '星期一至五',
    day2: '星期六至日',
    version: '版权所有(c) 2020 香港醫務檢測中心有限公司',
    privacy: '隐私政策',
    terms: '使用条款',
    Links1: '海外导航网',
    back: '返回主页',

  },
  ContractText: {
    name: '受测者姓名：',
    code: '报告编号：',
    phone: '手机号码：',
    send_sms: '发送验证码',
    send_sms_second: '重新发送',
    vertifys: '输入验证码',
    mailbox_btn: '确认',
    speaker: '备用验证',
    warning: '本人已阅读并同意网站的',
    statement: '私隐政策',
    report_search_description: '报告查询指引：',
    description_one: '网查功能于电子报告发出3小时后提供。',
    description_two: '请确保您输入的受测者名字及报告编号与收到的报告一致。',
    description_three: '根据指引输入手机号码，点击" 发送验证码 "，收到后输入验证码，点击" 确认 "查询。',
    description_four: '如未能查验报告，请致电 (+852) 3100 0477 向化验所查询。',
    description_five: '网站仅保留检测报告一年，您的报告于发出当日起计，如已<br>超过一年，无法查询。如需咨询，请致电我们。',
    cn: '内地(86)',
    hk: '香港(00852)',
    mo: '澳门(00853)',
  },
  HomeText: {
    p1_1_1: '专注',
    p1_1_1_2: '母血清基因筛选检测',
    p1_1_2: '最早6周检测',
    p1_1_3: '全港最快5小时出报告',
    p1_2_1: '香港医务化验师委员会认可',
    p1_2_1_2: '',
    p1_2_2: '香港知名品牌化验所',
    p1_2_3: '具高端分子学检测技术',
    p1_2_3_2: '',
    p1_3_1: '专业',
    p1_3_2: '高效',
    p1_3_3: '精准',
    p1_3_4: '优质',

    p2_title: '香港医务检测中心，你的首选，你的最佳选择',
    p2_action: '更多服务项目',
    p2_item_action: '查看详情',
    p2_1: '母血Y染色体检测',
    p2_2: '无创产前基因检测',
    p2_3: '亲子鉴定（产前或产后）',
    p2_3_add_on: '',

    p3_title: '化验所规格',
    p3_content: '化验所严格遵照ISO 9001和ISO 17025标准和指引操作，整个实验操作过程均有记录，由注册一级化验师(HKMLT Board)进行全面严格监管，确保每一份化验报告的结果是高质量，完全满足客户和管理要求。',

    p4_title: '荣誉与资质',
    p4_1: '香港医务化验师委员会认可及监管',
    p4_1_2: '',
    p4_2: '香港知名品牌化验所',
    p4_3: '高端分子学检测技术',

    p5_title: '科研技术',
    p5_1_1: '全自动设备',
    p5_1_2: '我们的先进实验室仪器包括全自动DNA提取系统、高度精准的样品处理仪器和准确的DNA检测分析技术。全自动的处理样本系统能取代人工操作，务求将化验过程中的污染问题减到最低。',
    p5_2_1: '实时聚合酶连锁反应技术',
    p5_2_2: '我们采用最先进的实时聚合酶连锁反应技术，把宝宝的DNA大量复制扩增和实时以荧光染剂侦测出其中是否含有Y染色体特定基因片段。在短时间内分析到最准确的结果。',
    p5_3_1: '20个独特序列的引物',
    p5_3_2: '我们利用多达20个在Y染色体片段中的特别标记来分析最终检测的结果。此检测具高敏度，准确率可达99.9%。',

    p6_1: '查询报告',
    p6_1_2: '输入框',
    p6_1_3: '立即查询',
    p6_2: '香港醫務檢測中心'
  },
  AboutText: {
    p1_title: '关于我们',
    p1_action: '返回主页',

    p2_title: '公司简介',
    p2_subtitle: '关于香港医务检测中心',
    p2_content: '我们以分子诊断技术和基因科技为主导。结合海外先进分子检测设备、自主研发的尖端基因检测技术，配合全面的数据库和资深的科研技术团队的分析，致力为我们宝贵的客户提供最专业、最高端、最全面的一站式基因检测服务。',


    p3_title: '我们的团队',
    p3_subtitle: '专家团队',
    p3_content: "我们的科研团队集合了分子检测中极具权威的专家，包括硕士级和博士级的科学顾问及具专业资格的化验师和技术人员，他们在分子诊断领域中拥有丰富的临床实战经验。医生顾问涵盖科目最全医生团队，提供多项医疗信息和建议",

    p4_title: '企业使命',
    p4_content_1: "希望利用我们的专业知识、创新精准的基因技术及优质贴心的服务，",
    p4_content_2: "努力为每一位尊贵客户带来最准确而全面的检测，从而提高下一代的生活水平。",
    p4_content_3: "我们积极与世界各地的组织合作、期望在分子检测领域中保持领先地位、",
    p4_content_4: "加深公众对基因检测的认识。",
    p4_content_5: "",
    p4_content_6: "",
    p4_content_7: "",

    p5_title: '企业文化',
    p5_1_1: '以人为本',
    p5_1_2_1: '以顾客为先，因应客户需求',
    p5_1_2_2: '提供精准的基因检测',
    p5_2_1: '关怀员工',
    p5_2_2_1: '以员工为先，为员工创造平台',
    p5_2_2_2: '提升个人价值',
    p5_3_1: '诚信负责',
    p5_3_2_1: '诚信待人，与客户互相',
    p5_3_2_2: '建立信任和负责的人际关系',
    p5_4_1: '追求卓越',
    p5_4_2_1: '持续研发创新，提升服务质量',
    p5_4_2_2: '为社会提供卓越的产品和服务',
    p5_4_2_3: '',
  },
  ContactUsText:{
    p1_title: '联络我们',
    p1_action: '返回主页',

    p2_title:'期望与您联系',
    p2_action:'发送',
    p2_1:'给我们意见',
    p2_2:'你的名字',
    p2_3:'你的电话',
    p2_4:'你的电邮',

    p3_tel:'(+852) 3100 0477',
    p3_fax:'(+852) 3102 0345',
    p3_email:'info@hkmedilab.com',
    p3_address:'香港沙田乡事会路138号新城市中央广场1座13楼11室',
  },
  YDnaTest: {
    p1_title: '母血Y染色体检测',
    p1_action: '返回主页',

    p2_content: "性别除了身体特征上的分别，在基因上也带着决定性的差别。男性第23对染色体组合为XY；女性则是XX。",

    p3_content: "在母亲怀孕初期，宝宝的游离DNA碎片会穿过胎盘进入母亲血液，这个时候可以透过采取母亲血液分离出宝宝的DNA，然后利用实时聚合酶连锁反应技术(PCR)扩增宝宝的DNA做检测。",
    p4_content_1: "男性的Y基因是唯一只遗传自亲生父亲之物质。",
    p4_content_2: "透过Y基因比对，让我们能够追溯父系关系。同时检测亦可以协助父母做好Y染色体遗传病的应对措施。",

    p5_title: "检测方案",
    p5_1_1: "测试名称",
    p5_1_2: "6周或以上母血Y染色体检测",
    p5_1_3: "6周或以上母血Y染色体检测（特快）",
    p5_2_1: "测试需时",
    p5_2_2: "1个工作日",
    p5_2_3: "5个小时",
    p5_3_1: "样本要求",
    p5_3_2: "6mL EDTA采血管x2",
    p5_3_3: "6mL EDTA采血管x2",

    advantages_title: "测试特点",
    advantages_1_1: "加急报告",
    advantages_1_2: "全港最快5小时即日有结果",
    advantages_2_1: "高准确度",
    advantages_2_2: "准确率达99.9%",
    advantages_3_1: "高敏感度",
    advantages_3_2: "早达6周即可检测",
    advantages_4_1: "非入侵性",
    advantages_4_2: "只需采取母血，无流产风险",

    p7_title: "检测流程须知",
    p7_1: "预约登记",
    p7_2: "采集血液",
    p7_3: "运送样本",
    p7_4: "样本检测",
    p7_5: "检测结果",

    p8_title: "注意事项",
    p8_1_1: "若发生以下情况，",
    p8_1_2: "请在检测前先致电诊所医护人员咨询",

    p8_2_1: "1. 曾接受过器官移植或半年内曾接受过输血",
    p8_2_2: "2. 半年内曾怀有男胎",
    p8_2_3: "3. 怀有多胞胎",
    p8_2_4: "4. 人工受孕",
    p8_2_5: "5. 胎儿是镶嵌体",
  },
  NPrenatalTest: {
    p1_title: '无创产前基因检测',
    p1_action: '返回主页',

    p2_content: "染色体异常的精子和卵子是随机性出现的，机率随年纪递增，因此每对父母均有机会诞下患有染色体异常疾病的宝宝。",
    p3_content: "此类疾病至今并无有效治疗方法，但只要做好产前筛检，就能减少诞下患病宝宝的机会。美国妇产科医学会(ACOG)已经将非侵入性胎儿染色体基因检测列为产前筛检的建议项目。",
    p4_content: "无创产前检测是目前产检的最新技术，与传统的入侵式产检如绒毛活检或羊膜穿刺等不同，只需采集母血就能获得宝宝的基因讯息，透过先进的实时聚合酶连锁反应(PCR)及次世代定序技术(NGS)，计算出胎儿患有染色体异常（如唐氏综合症）的风险率，准确率高而且无流产风险。",

    p5_title: "染色体异常大致可分为三类:",
    p5_subtitle: "染色体",
    p5_1_1: "多倍体式",
    p5_1_2: "非整倍体",
    p5_2_1: "微缺失",
    p5_3_1: "基因突变",

    p6_title: "产前检测比较",
    p6_content: "无创产前基因检测是一项具高准确度的产前筛查技术，比传统入侵性检测(如绒毛活检、羊膜穿刺等检测)更为安全，不会导致流产和羊膜腔感染并且无流产风险，准确度高于99%。此技术只需抽取少量孕妇血液，便可检测宝宝是否有潜在的疾病风险。",

    advantages_title: "测试特点",
    advantages_1_1: "加急报告",
    advantages_1_2: "5-7个工作日出报告",
    advantages_2_1: "高准确度",
    advantages_2_2: "准确率达99%",
    advantages_3_1: "高敏感度",
    advantages_3_2: "早达6周即可检测",
    advantages_4_1: "非入侵性",
    advantages_4_2: "只需采取母血，无流产风险",

    p7_1_1: "检测名称",
    p7_1_2: "无创产前检测",
    p7_1_3: "羊膜穿刺",
    p7_1_4: "绒毛膜穿刺",
    p7_1_5: "胎儿颈部透明层检查(NT)",
    p7_1_6: "早孕期筛查",
    p7_1_7: "中孕期筛查",
    p7_1_8: "脐带静脉穿刺",
    p7_2_1: "准确度",
    p7_2_2: ">99%",
    p7_2_3: ">99%",
    p7_2_4: ">99%",
    p7_2_5: "60%-80%",
    p7_2_6: "80%-90%",
    p7_2_7: "60%-90%",
    p7_2_8: ">99%",
    p7_3_1: "孕周(周数)",
    p7_3_2: "≥9",
    p7_3_3: "16-20",
    p7_3_4: "11-13",
    p7_3_5: "11-13",
    p7_3_6: "11-13",
    p7_3_7: "16-19",
    p7_3_8: ">20",
    p7_4_1: "流产风险",
    p7_4_2: "无",
    p7_4_3: "0.5-1%",
    p7_4_4: "1-2%",
    p7_4_5: "无",
    p7_4_6: "无",
    p7_4_7: "无",
    p7_4_8: "1-2%",
    p7_5_1: "报告周期(工作日)",
    p7_5_2: "5-7",
    p7_5_3: "14-21",
    p7_5_4: "14-21",
    p7_5_5: "1-2",
    p7_5_6: "1-2",
    p7_5_7: "1-2",
    p7_5_8: "5-7",
  },
  PaternityTest: {
    p1_title: '亲子鉴定（产前或产后）',
    p1_title_2: '',
    p1_action: '返回主页',
    p2_content: '无论男孩女孩，都有两组染色体，一组源自父亲，另一组源自母亲。只需把婴儿的染色体跟另一个体的染色体作比对，吻合的便是婴儿的亲父亲母，准确率达99.99%。',

    p3_title:'产前',
    p3_subtitle:'亲子鉴定',
    p3_1:'早在怀孕初期，胎儿的染色体碎片便会透过胎盘进入母亲血液，最早7周母亲血液内便有足够碎片浓度作检测，无需抽取胎儿任何组织便可检测，比传统抽羊水或绒毛更安全，无流产风险。',
    p3_2:'样本：',
    p3_2_1:'静脉血、口腔拭子、指甲、5-10根带毛囊的头发',
    p3_3:'可提供检验的关系：',
    p3_3_1:'父子/父女',
    p4_title:'产后',
    p4_subtitle:'亲子鉴定',
    p4_1:'DNA不仅可鉴定子女和父母的亲子关系，还可用于鉴定亲属关系，判断两人之间是否存在血缘关系。',
    p4_2:'样本：',
    p4_2_1:'静脉血、口腔拭子、指甲、5-10根带毛囊的头发',
    p4_3:'可提供检验的关系：',
    p4_3_1:'父子/父女',
    p4_3_2:'兄弟姊妹',
    p4_3_3:'叔侄',
    p4_3_4:'母子/母女',
    p4_3_5:'祖孙',

    advantages_title: "测试特点",
    advantages_1_1: "加急报告",
    advantages_1_2: "3-5个工作天出报告",
    advantages_2_1: "高准确度",
    advantages_2_2: "准确率达99.99%",
    advantages_3_1: "高敏感度",
    advantages_3_2: "早达7周即可检测",
    advantages_4_1: "非入侵性",
    advantages_4_2: "只需采取母血，无流产风险(产前)",
    advantages_4_2_1: "",
  },
};


export {

  MessageCh

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js